import { render, staticRenderFns } from "./ResolutionStatusChips.vue?vue&type=template&id=58382d06&"
import script from "./ResolutionStatusChips.vue?vue&type=script&lang=js&"
export * from "./ResolutionStatusChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports